// extracted by mini-css-extract-plugin
export default {"wrapper":"LoaderModal_wrapper__WBL4D","icon":"LoaderModal_icon__FoIQ5"};